import React, { useState } from 'react';
import '../styles/armsform.css';
import imageCompression from 'browser-image-compression'; // Import image compression library

function ComplaintForm() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        cnic: '',
        complaint: '',
        priority: 'moderate',
        status: 'open',
    });
    const [file, setFile] = useState(null); // State for file
    const [responseMessage, setResponseMessage] = useState('');
    const [showPopup, setShowPopup] = useState(false); // State for popup visibility
    const [fileError, setFileError] = useState(''); // State to track file validation error

    const MAX_FILE_SIZE_MB = 10; // Max file size in MB

    // Handle form data changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleFileChange = async (e) => {
        const selectedFile = e.target.files[0];

        if (selectedFile) {
            // Check if the file size exceeds the limit (2MB)
            if (selectedFile.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
                setFileError(`File size should not exceed ${MAX_FILE_SIZE_MB} MB`);
                setFile(null); // Reset file if the size exceeds
            } else {
                setFileError('');
                // Compress image if it is below the size limit
                try {
                    const compressedFile = await imageCompression(selectedFile, {
                        maxSizeMB: MAX_FILE_SIZE_MB,
                        maxWidthOrHeight: 800, // Set the max dimensions for compression
                    });
                    setFile(compressedFile);
                } catch (error) {
                    console.error('Error compressing image:', error);
                }
            }
        }
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!file && fileError === '') {
            setFileError('Please attach a valid file.');
            return;
        }

        const formDataToSend = new FormData();
        formDataToSend.append('name', formData.name);
        formDataToSend.append('email', formData.email);
        formDataToSend.append('cnic', formData.cnic);
        formDataToSend.append('complaint', formData.complaint);
        formDataToSend.append('priority', formData.priority);
        formDataToSend.append('status', formData.status);

        if (file) {
            formDataToSend.append('attachment', file);
        }

        try {
            const response = await fetch('https://chaman.gob.pk/eac_backend/submit_complaint.php', {
                method: 'POST',
                body: formDataToSend, // Send form data
            });

            // Check if response is okay
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }

            const result = await response.json(); // Expect JSON response
            setResponseMessage(result.message);

            setFormData({
                name: '',
                email: '',
                cnic: '',
                complaint: '',
                priority: 'moderate',
                status: 'open',
            });
            setFile(null); // Reset file state

            // Show the popup on success
            setShowPopup(true);
            setTimeout(() => setShowPopup(false), 3000); // Hide popup after 3 seconds
        } catch (error) {
            console.error('Error submitting complaint:', error);
            setResponseMessage('Error submitting complaint. Please try again.');
        }
    };

    return (
        <div className="arms-container">
            <form onSubmit={handleSubmit}>
                <div className="left-section">
                    <div>
                        <label htmlFor="name">Name:</label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            placeholder="John Doe"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div>
                        <label htmlFor="email">Phone No:</label>
                        <input
                            type="text"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div>
                        <label htmlFor="cnic">CNIC No:</label>
                        <input
                            type="text"
                            id="cnic"
                            name="cnic"
                            value={formData.cnic}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div>
                        <label htmlFor="complaint">Complaint:</label>
                        <textarea
                            id="complaint"
                            name="complaint"
                            value={formData.complaint}
                            onChange={handleChange}
                            required
                        ></textarea>
                    </div>

                    <div>
                        <label htmlFor="attachment">Attachment:</label>
                        <input
                            type="file"
                            id="attachment"
                            onChange={handleFileChange}
                        />
                        {fileError && <p style={{ color: 'red' }}>{fileError}</p>}
                    </div>

                    {/* <div>
                        <label htmlFor="priority">Priority:</label>
                        <select name="priority" value={formData.priority} onChange={handleChange}>
                            <option value="poor">Poor</option>
                            <option value="moderate">Moderate</option>
                            <option value="high">High</option>
                        </select>
                    </div> */}

                    {/* <div>
                        <label htmlFor="status">Status:</label>
                        <select name="status" value={formData.status} onChange={handleChange}>
                            <option value="open">Open</option>
                            <option value="in-progress">In Progress</option>
                            <option value="resolved">Resolved</option>
                        </select>
                    </div> */}

                    <button type="submit">Submit</button>
                </div>
            </form>

            {/* Popup */}
            {showPopup && (
                <div style={popupStyle}>
                    Data saved successfully!
                </div>
            )}
        </div>
    );
}

// Popup styling
const popupStyle = {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    padding: '10px 20px',
    backgroundColor: '#3b82f6',
    color: 'white',
    borderRadius: '5px',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
    zIndex: 1000,
};

export default ComplaintForm;
